import React from 'react';
import { ToggleSwitch } from '../../../sdk';

/**
 * Progress bar editor
 */
export function ProgressEditor({ progress, onChange }) {
  const hasProgress = !!progress;
  
  const handleToggle = (enabled) => {
    if (enabled) {
      onChange({ label: 'Raised', current: 0, total: 100000 });
    } else {
      onChange(null);
    }
  };

  return (
    <div className="field-container">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="module-header">Progress Bar</div>
          <div className="module-desc">Show fundraising progress.</div>
        </div>
        <ToggleSwitch
          checked={hasProgress}
          onChange={(checked) => handleToggle(checked)}
          size="sm"
        />
      </div>

      {hasProgress && (
        <div className="mt-3 space-y-3">
          <div>
            <div className="text-[11px] text-white/55 mb-1">Label</div>
            <input
              value={progress.label || ''}
              onChange={(e) => onChange({ ...progress, label: e.target.value })}
              className="input-base"
              placeholder="e.g. Raised"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <div className="text-[11px] text-white/55 mb-1">Current (€)</div>
              <input
                type="number"
                value={progress.current || 0}
                onChange={(e) => onChange({ ...progress, current: parseInt(e.target.value) || 0 })}
                className="input-base"
                placeholder="0"
              />
            </div>
            <div>
              <div className="text-[11px] text-white/55 mb-1">Total (€)</div>
              <input
                type="number"
                value={progress.total || 100000}
                onChange={(e) => onChange({ ...progress, total: parseInt(e.target.value) || 100000 })}
                className="input-base"
                placeholder="100000"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
